<form [formGroup]="flowsMoveAcquisitionPrivateSwitchForm" 
(click)="stopEventPropagation($event)" 
(mousedown)="stopEventPropagation($event)" 
(scroll)="stopEventPropagation($event)" 
(mousemove)="stopEventPropagation($event)" 
(ngSubmit)="onSubmit()">

  <ui-fieldset variant="step" [alignInputs]="false" class="ui-mb-2xl ui-block">
    <span step>1</span>
    <section class="ui-p-sm sm:ui-p-lg md:ui-px-2xl lg:ui-py-xl lg:ui-px-3xl">
      <header class="ui-font-bold ui-text-lg">
        <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep1Heading]"></ng-content>
      </header>
      <p class="ui-pb-sm">
        <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep1Description]"></ng-content>
      </p>
      <ui-input formControlName="isMoving" (keyup.enter)="enableDisable(); scrollToPosition();" (click)="enableDisable(); scrollToPosition();" name="isMoving"
        variant="radio-enhanced-small" required>
        <ui-input-option value="false">
          <div class="ui-flex ui-items-center">
            <span class="ui-flex ui-justify-center ui-items-center self-center ui-icon ui-icon-house ui-pr"></span>
            <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep1Option1Label]"></ng-content>
          </div>
        </ui-input-option>
        <ui-input-option value="true">
          <div class="ui-flex ui-items-center">
            <span class="ui-flex ui-justify-center ui-items-center self-center ui-icon ui-icon-moving ui-pr"></span>
            <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep1Option2Label]"></ng-content>
          </div>
        </ui-input-option>
      </ui-input>
      <div class="ui-mt">
        <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep1Note]"></ng-content>
      </div>
    </section>
  </ui-fieldset>

  <ui-fieldset variant="step" [disabled]="isMovingFormControl.invalid" [alignInputs]="false">
    <span #secondStep step class="ui-inline-block">2</span>
    <section *ngIf="hasActiveMovePremieCampaign==='true' && isMovingFormControl.value===true"
      class="sm:ui-pb-lg md:ui-px-2xl lg:ui-pb-xl lg:ui-px-3xl sm:ui-px-xs xs:ui-px-2xs">
    <div
      class="xs:ui-border-l-8 xs:ui-border-r-8 xs:ui-border-primary-white _sm:ui-border-r-0 _sm:ui-border-l-0 ui-bg-background-blue ui-pb-xl ui-w-full ui-rounded sm:ui-pr-xs xs:ui-pr-xs">
      <h2 class="ui-w-full ui-block ui-h4 xs:ui-leading-2xl ui-text-primary-black ui-text-lg ui-pt-xl ui-pl-xl ui-pb-0">
        <ng-content select="[flowsMovePrivateSwitchStep2PremieCustomerOfferHeadlineMove]"></ng-content>
      </h2>
      <div class="ui-flex ui-flex-row ui-items-center">
        <div class="ui-flex-grow lg:ui-pr-lg md:ui-pr-sm sm:ui-pr-xs xs:ui-pr-2xs">
          <h3 class="ui-h3 ui-text-primary-black ui-pl-xl xs:ui-text-2xl xs:ui-leading-sm md:ui-text-2xl md:ui-leading-2xl">
            <ng-content select="[flowsMovePrivateSwitchStep2PremieCampaignHeading]"></ng-content>
          </h3>
          <p class="ui-text-primary-black ui-pl-xl ui-text-sm">
            <ng-content select="[flowsMovePrivateSwitchStep2PremieCampaignDescriptionText]"></ng-content>     
          </p>
        </div>
        <div class="ui-flex ui--mt-2xl lg:ui-pr-2xl md:ui-pr-xl sm:ui-pr-xs xs:ui-pr-xs">
          <div
            class="premium-discount-image">
            <ng-content class="ui-rounded-full" select="[flowsMovePrivateSwitchStep2PremieCampaignImage]"></ng-content>
          </div>
        </div>
      </div>
    </div>
    </section>
    <section *ngIf="hasActiveAcquisitionPremieCampaign==='true' && isMovingFormControl.value===false"
    class="sm:ui-pb-lg md:ui-px-2xl lg:ui-pb-xl lg:ui-px-3xl sm:ui-px-xs xs:ui-px-2xs">
    <div
      class="campaign xs:ui-border-l-8 xs:ui-border-r-8 xs:ui-border-primary-white _sm:ui-border-r-0 _sm:ui-border-l-0 ui-bg-background-blue ui-pb-xl ui-w-full ui-rounded sm:ui-pr-xs xs:ui-pr-xs">
      <h2 class="ui-w-full ui-block ui-h4 xs:ui-leading-2xl ui-text-primary-black ui-text-lg ui-pt-xl ui-pl-xl ui-pb-0">
        <ng-content select="[flowsAcquisitionPrivateSwitchStep2PremieCustomerOfferHeadlineAcq]"></ng-content>
      </h2>
      <div class="ui-flex ui-flex-row ui-items-center">
        <div class="ui-flex-grow lg:ui-pr-lg md:ui-pr-sm sm:ui-pr-xs xs:ui-pr-2xs">
          <h3 class="ui-h3 ui-text-primary-black ui-pl-xl xs:ui-text-2xl xs:ui-leading-sm md:ui-text-2xl md:ui-leading-2xl">
            <ng-content select="[flowsAcquisitionPrivateSwitchStep2PremieCampaignHeading]"></ng-content>
          </h3>
          <p class="ui-text-primary-black ui-pl-xl ui-text-sm">
            <ng-content select="[flowsAcquisitionPrivateSwitchStep2PremieCampaignDescriptionText]"></ng-content>
          </p>
        </div>
        <div class="ui-flex ui--mt-2xl lg:ui-pr-2xl md:ui-pr-xl sm:ui-pr-xs xs:ui-pr-xs">
          <div
            class="premium-discount-image">
            <ng-content class="ui-rounded-full" select="[flowsAcquisitionPrivateSwitchStep2PremieCampaignImage]"></ng-content>
          </div>
        </div>
      </div>
    </div>
  </section>


    <section class="ui-p-sm sm:ui-p-lg md:ui-px-2xl lg:ui-py-xl lg:ui-px-3xl">
      <header class="ui-font-bold ui-text-lg">
        <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep2Heading]"></ng-content>
      </header>
      <p>
        <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep2Description]"></ng-content>
      </p>
      <!-- todo: why not merge the section and the div into one tag? -->
      <section>
        <div class="ui-grid ui-grid-cols-1 md:ui-grid-cols-2 ui-gap-sm md:ui-gap lg:ui-gap-lg">
          <div>
            <div class="ui-font-bold ui-pt-sm ui-pb-sm">
              <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep2DeliveryHeading]"></ng-content>
            </div>
            <ui-input formControlName="postalCode" name="postalCode" (input)="enableDisable()" postalCode required
              class="ui-w-full">
              <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep2DeliveryPostalCodeLabel]"></ng-content>
            </ui-input>
          </div>
          <div class="md:ui-pt-xl">
            <div *ngIf="state === 'loading-postalcode'" class="md:ui-pt-lg ui-mt-sm ui-pb-xs ui-text-lg">
              <span ui-loading [loading]="true">AAaaAAaAAaA</span>
            </div>
            <output *ngIf="isCompletedPostalCode" name="postalTown" for="postalCode"
              class="md:ui-pt-lg ui-mt-sm ui-pb-xs ui-block ui-text-lg">
              <span
                class="ui-icon ui-icon-checkmark before:ui-text-xs ui-text-secondary-green ui-pr-xs ui-pl-xs"></span>
              {{ postalTown }}
            </output>
            <section *ngIf="isBetweenGridAreas">
              <!-- todo: replace tag aside with a more or less specific tag since the content is strongly connected to the form and associated to the ui-input
              probably a fieldset and legend for the section to input gridarea
             -->
              <aside class="ui-pt-xs ui-pb ui-block">
                <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep2DeliveryGridAreaMessage]"></ng-content>
              </aside>
              <ui-input formControlName="gridArea" name="gridArea" gridAreaId required class="ui-w-full">
                <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep2DeliveryGridAreaLabel]"></ng-content>
              </ui-input>
              <div *ngIf="state === 'loading-gridarea'" class="ui-pt-xs ui-pb-xs ui-text-lg">
                <span ui-loading [loading]="true">AAaa</span>
              </div>
              <output *ngIf="isValidGridArea" name="gridArea" for="gridArea"
                class="ui-pt-xs ui-pb-xs ui-block ui-text-lg">
                <span
                  class="ui-icon ui-icon-checkmark before:ui-text-xs ui-text-secondary-green ui-pr-xs ui-pl-xs"></span>
                <ng-container [ngSwitch]="energyArea">
                  <ng-container *ngSwitchCase="'SN1'">
                    <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep2DeliveryEnergyArea1Label]"></ng-content>
                  </ng-container>
                  <ng-container *ngSwitchCase="'SN2'">
                    <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep2DeliveryEnergyArea2Label]"></ng-content>
                  </ng-container>
                  <ng-container *ngSwitchCase="'SN3'">
                    <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep2DeliveryEnergyArea3Label]"></ng-content>
                  </ng-container>
                  <ng-container *ngSwitchCase="'SN4'">
                    <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep2DeliveryEnergyArea4Label]"></ng-content>
                  </ng-container>
                </ng-container>
              </output>
              <!-- todo: replace with output or strong tag o with ui-error decorator to indicate the outcome of this formsection -->
              <ui-error [error]="error === 'fetch-gridarea'">
                <div *ngIf="error === 'fetch-gridarea'" class="ui-h-5xl ui-border-primary-black-50 ui-w-full"></div>
                <span #message>
                  <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep2ErrorMessage]"></ng-content>
                </span>
              </ui-error>
            </section>
          </div>
        </div>

      </section>

      <ng-container>
        <section class="lg:ui-grid lg:ui-row-span-1">
          <header class="ui-font-bold ui-pt ui-pb-xs">
            <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep2AccommodationTypeHeading]"></ng-content>
          </header>
          <!-- todo: use option-inputs with fieldsets -->
          <ui-input formControlName="buildingType" name="buildingType" variant="radio-enhanced-small" required
            [readonly]="(isMovingFormControl
    .invalid) || (!isCompletedPostalCode && !isValidGridArea)">
            <ui-input-option value="apartment">
              <div class="ui-flex ui-items-center">
                <span
                  class="ui-flex ui-justify-center ui-items-center self-center ui-icon ui-icon-apartment ui-pr"></span>
                <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep2AccommodationTypeApartmentButtonLabel]">
                </ng-content>
              </div>
            </ui-input-option>
            <ui-input-option value="villa">
              <div class="ui-flex ui-items-center">
                <span class="ui-flex ui-justify-center ui-items-center self-center ui-icon ui-icon-house ui-pr"></span>
                <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep2AccommodationTypeVillaButtonLabel]">
                </ng-content>
              </div>
            </ui-input-option>
          </ui-input>
        </section>

        <!-- Slider Component -->
        <!-- <ui-loading [loading]="state==='loading-consumption'"> -->
        <vf-input-range-slider [disabled]="state=='loading-consumption'"
          class="ui-block ui-w-full ui-pt-4xl lg:ui-w-9/12 ui-m-auto" (rangeSliderEvent)="houseAreaSelected($event)"
          [initialValue]="buildingTypeFormControl.value === 'villa' ? 120: 100"
          [disabled]="!buildingTypeFormControl.touched">
        </vf-input-range-slider>
        <!-- </ui-loading> -->

        <!-- Annual Consumption  -->
        <!-- todo: include the header style into the div below. Header has a semantic meaning and here it is merely used for styling. -->
        <header class="ui-font-bold ui-pt-2xl ui-pb-xs ui-invisible">HEADER</header>
        <div class="ui-flex ui-flex-row ui-flex-wrap ui-items-start ui-justify-left ui-gap-2xs ui-flex-auto ui-pb ui-text-xl">
          <!-- todo: replace bold with class that uses a predefined tailwind font. Also use a tag that has a semantic meaning inside the form.  -->
          <div class="ui-font-bold">
            <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep2ConsumptionPerYearHeading]"></ng-content>
          </div>
          <div>
            <ui-loading [loading]="state==='loading-consumption'">
              <ui-input formControlName="annualEstimatedConsumption" name="annualEstimatedConsumption"
                variant="number-underline" [value]="estimatedKwhConsumption" class="min-w-0">
              </ui-input>
            </ui-loading>
          </div>
          <div>
            <!-- todo: replace label with a more semantically correct one -->
            <label class="ui-font-regular">{{getConsumptionUnitValue()}}</label>
          </div>
        </div>
      </ng-container>
      <!-- Information message -->
      <!-- todo: replace aside with something else since the aside tag is intended to represent information that may be placed outside the formcontext
        <em>, <p>, <div>, <section>, <h1-6>...
      
      -->
      <aside *ngIf="isConsumptionLow" class="ui-message ui-w-full ui-py-xl">
        <ng-content select="[flowsMoveAcquisitionPrivateSwitchLowConsumptionErrorMessage]"></ng-content>
      </aside>
      <aside *ngIf="isConsumptionHigh" class="ui-message ui-w-full ui-py-xl">
        <ng-content select="[flowsMoveAcquisitionPrivateSwitchHighConsumptionErrorMessage]"></ng-content>
      </aside>
      <aside class="ui-message">
        <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep2Note]"></ng-content>
      </aside>
      <button ui-button size="large" [disabled]="flowsMoveAcquisitionPrivateSwitchForm?.invalid"
        class="ui-w-full ui-py-xl">
        <ng-content select="[flowsMoveAcquisitionPrivateSwitchStep2SubmitButtonLabel]"></ng-content>
      </button>
    </section>
  </ui-fieldset>
</form>